import { Button } from "@ttc3k/trekker";
import { DatabaseSearch } from "iconoir-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FeatureGate } from "shared/contextProviders/featureFlags";
import { FeatureFlags } from "shared/featureFlags";
import { OrgOverviewModal } from "shared/components/organisms/OrgOverviewModal";

type OrgOverviewSearchProps = {
  organizationId: string;
};

export const OrgOverviewSearch = ({
  organizationId,
}: OrgOverviewSearchProps) => {
  const { t } = useTranslation("core", { keyPrefix: "ORG_OVERVIEW" });
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <FeatureGate flag={FeatureFlags.OrgLevelGlobalSearch}>
      <Button
        visual={"unstyled"}
        Icon={DatabaseSearch}
        p={"0"}
        borderRadius={"full"}
        transitionProperty={"transform"}
        transitionDuration={"0.2s"}
        _hover={{
          transform: "scale(1.1)",
        }}
        _focusVisible={{
          transform: "scale(1.1)",
          outlineColor: "border.light",
          outlineOffset: "4px",
          outlineWidth: "1px",
          outlineStyle: "solid",
        }}
        title={t("ENTRY_BUTTON_LABEL")}
        onClick={() => setIsModalOpen(true)}
      />
      <OrgOverviewModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        organizationId={organizationId}
      />
    </FeatureGate>
  );
};
